import { Typography } from '@material-ui/core';
import { navigate } from '@reach/router'
import { Button, Cards, Spinner } from 'ams-ui-reactkit';
import React, { useEffect, useRef, useState } from 'react'
import { TitleBlock } from '../../../atoms';
import { TemplateProps } from '../../../journeys/journey/Interfaces';
import { FormList, SignatureCard } from '../../../molecules';
import './DigitalSignature.scss'
import { StoreContext } from '../../../context';
import { useContextSelector } from '@fluentui/react-context-selector';
import { getCounterPartsDetails } from "../../../graphql/getCounterParts.query"
import { saveCounterPartsToDB } from "../../../graphql/saveCounterParts.mutation"
import { validateField } from "./../../../common/Validators"
import { getSignatureByIndex } from "./../../../common/GlobalUtils";
import { get } from 'lodash';
import useSiganture from "./useSiganture";
import useCommon from "../common/useCommon"
import { getCustomerId, getDailysheetId, phoneFormat } from '../../../utils/Utils';
import { actionTypeConstants } from '../../../utils';

const DigitalSignature: React.FC<TemplateProps> = (props: any) => {

    const { templateProps } = props;
    const [disabled, setDisabled] = useState(true);

    const [btnLoader, setBtnLader] = useState(false)
    const signRef = useRef<SignaturePad>(null);
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);
    const appState: any = useContextSelector(StoreContext, store => store?.appState);
    const customerInfo: any = useContextSelector(StoreContext, store => store?.appState?.customerInfo);
    const [loading, setLoading] = useState(false);
    const signatures: any = useContextSelector(StoreContext, store => store?.appState?.signatures);
    const signByInd = getSignatureByIndex(signatures?.list, 1);
    const [sign, setSign] = useState<any>(signByInd?.getUrl || null);
    const { callClearSignature, uploadSignature } = useSiganture();
    const { updateBolStatus } = useCommon();
    const [signSize, setSignSize] = useState<number>(0)

    const validateSignatureBySize = (process.env.REACT_APP_VALIDATE_SIGN_BY_SIZE === "true") ? true : false;
    const validSignatureSize = process.env.REACT_APP_SIGN_SIZE || 9000;

    const [isFormValid, setIsFormValid] = useState(false);
    const [invalidSignMessage, setInvalidSignMessage] = useState("");

    useEffect(() => {
        try {
            if (!customerInfo?.email || !customerInfo?.phone) {
                setIsFormValid(false)
            } else {
                setFormfields()
            }
        } catch {
            console.log('Validation Error')
        }

    }, [customerInfo?.email, customerInfo?.phone])

    useEffect(() => {

        let isButtonDisabled = true;
        if (isFormValid && signByInd?.getUrl && signSize !== 0) {
            isButtonDisabled = false;
        }
        else if (isFormValid && sign) {
            isButtonDisabled = false;

            if (validateSignatureBySize && (signSize <= validSignatureSize)) {
                isButtonDisabled = true;
            }
        }
        setDisabled(isButtonDisabled);

    }, [isFormValid, signSize]);

    useEffect(() => {
        const cid = getCustomerId();

        if (cid) {
            getCounterPartsData(cid)
        }
        if (signByInd?.getUrl) {
            setSignSize(calculateBase64SignSize(signByInd?.getUrl)); // setting signature url as size to disable button on sign clear
        }


    }, []);

    const setFormfields = () => {
        let hasErr = false;
        templateProps?.card?.formFields?.forEach((field: any) => {
            if (field?.type === 'tel') {
                let fieldVal = get(customerInfo, `${field.id}`, "");
                let isValidPhone = validateField({ ...field, value: fieldVal });
                if (isValidPhone && !hasErr)
                    hasErr = true;
            }
            if (field?.type === 'email') {
                var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i); // NOSONAR 
                let emailVal = pattern.test(get(appState, `${field.dataField}`, ""));
                if (!emailVal && !hasErr)
                    hasErr = true;
            }
        })
        setIsFormValid(!hasErr);
    }

    const getCounterPartsData = async (customerId: any) => {
        setLoading(true)
        const resp = await getCounterPartsDetails(customerId)
        let formattedNum: any = resp?.phone;
        try {
            formattedNum = phoneFormat(resp.phone || "");
        } catch { }
        setLoading(false)
        dispatch({
            'type': actionTypeConstants.UPDATE_CUSTOMER_INFO,
            'payload': {
                ...resp,
                phone: formattedNum
            }
        })
    }

    const handleFormChange = (e: any, field: any, value: any) => {
        dispatch({
            'type': actionTypeConstants.UPDATE_CUSTOMER_INFO,
            'payload': {
                [field]: value
            }
        })

    }
    // CALL SAVE API

    const handleSubmit = async () => {
        let params = {
            "customerId": getCustomerId(),
            "phone": customerInfo?.phone,
            "email": customerInfo?.email
        }

        saveCounterPartsToDB(params).then((dataResults: any) => {
            console.log("RESULT", dataResults)
        }).catch((error: any) => {
            console.log("Save Counter Parts (saveCounterPartsToDB) Error:", error)
        })
        setBtnLader(true);

        if (signByInd && !signByInd?.getUrl && signByInd?.putUrl){

            await uploadSignature(sign, signByInd)
            .then( (resp:any) => {
               
                if(resp?.ok){
                    setBtnLader(false);
                    updateBolStatus(getCustomerId(), getDailysheetId(), "SIGNED");
                    navigate(templateProps?.nextScreen || '/');
                }else{
                    setBtnLader(false);
                    setInvalidSignMessage("Unable to upload signature due to technical issue. Please try after sometime.");
                    console.log("upload Signature failed in DG page");
                }
            }).catch( err => {
                setBtnLader(false);
                console.log("DG upload Signature err ", err);
            })
        }
        if (signByInd && signByInd?.getUrl && !signByInd?.putUrl){
            setBtnLader(false);
            updateBolStatus(getCustomerId(), getDailysheetId(), "SIGNED");
            navigate(templateProps?.nextScreen || '/');
        }
           

    }


    const calculateBase64SignSize = (base64: any) => {
        let size = 0;
        if (base64) {
            const buffer = Buffer.from(base64?.substring(base64?.indexOf(',') + 1));
            size = buffer?.length || 0;
        }

        return size;

    }

    const handleSignEnd = (evt: any) => {
        // @ts-ignore
        const signatureSize = calculateBase64SignSize(signRef?.current?.getTrimmedCanvas()?.toDataURL());

        if (validateSignatureBySize && (signatureSize <= validSignatureSize)) {
            setInvalidSignMessage("We couldn't detect a signature.");

        } else {
            // @ts-ignore
            setSign(signRef?.current?.getTrimmedCanvas()?.toDataURL() || "")
            setInvalidSignMessage("");
            setSignSize(signatureSize);
        }
    }

    const clearSignature = async () => {
        if (signByInd && signByInd?.getUrl && !signByInd?.putUrl)
            callClearSignature(signByInd)
        setSign("");
        setInvalidSignMessage("");
        setSignSize(0);
        signRef?.current?.clear()
    }

    const getFormData = () => {
        return {
            "customerInfo.email": customerInfo?.email || "",
            "customerInfo.phone": customerInfo?.phone || "",
        }
    }

    return (
        <div className="baseContainerBlock">
            {templateProps.title && <TitleBlock title={templateProps.title} />}
            <Cards variant="default">
                <div className="cardOutline">

                    {templateProps.card.title && <Typography variant="body2" variantMapping={{ body2: "div" }} className="formTitle color-red">
                        {templateProps.card.title}
                    </Typography>}
                    {loading ? <div className='flex-center-50h'>
                        <Spinner />
                    </div>
                        :
                        <div className='my-16 mx-0'>
                            {templateProps.card && <FormList
                                list={templateProps.card.formFields}
                                onChange={handleFormChange}
                                formData={getFormData()}
                            />}
                        </div>
                    }
                    {templateProps.card.footerText && <Typography variant="subtitle2" variantMapping={{ subtitle2: "div" }} className='color-red' align="center">
                        {templateProps.card.footerText}
                    </Typography>}
                </div>
            </Cards>
            <div className="noteText">
                {templateProps.noteText && <Typography variant="caption" className='color-grey lh-16'>
                    {templateProps.noteText}
                </Typography>}
            </div>

            <div>

                {
                    <SignatureCard
                        title={templateProps?.signCard?.title}
                        signRef={signRef}
                        onEnd={handleSignEnd}
                        onBegin={() => { setInvalidSignMessage(""); }}
                        sign={sign || ""}
                        populate={signByInd?.getUrl ? true : false}
                        handleClearClick={clearSignature}
                        hideClear={customerInfo?.isCompleted}
                        signHere={templateProps?.signCard?.signHere || "SHIPPER/CUSTOMER SIGN HERE"}
                    />
                }
                <span className='color-red fw-500'>{invalidSignMessage}</span>
            </div>

            <div className="staticFixedButton">
                <Button
                    text={templateProps?.button}
                    onClick={handleSubmit}
                    color="primary"
                    variant="contained"
                    size="large"
                    disabled={disabled}
                    loading={btnLoader}
                />
            </div>
        </div>
    )
}

export default DigitalSignature
